import type {
	MemberAttribute,
	UpdateMemberAttributeRequest,
} from "@di-devs/member-feature-plugin/shared";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import type { FeatureClient } from "@/config/client";
import { COMMONS } from "@/utils";
import { queries } from "./index";

export const useListMemberAttributes = (
	client: FeatureClient,
	options?: { enabled?: boolean },
) => {
	return useQuery({
		queryFn: client.listMemberAttributes,
		queryKey: queries.memberAttributes._def,
		enabled: options?.enabled,
	});
};
export const useCreateMemberAttribute = (client: FeatureClient) => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: client.createMemberAttribute,
		mutationKey: queries.memberAttributes._def,
		onSuccess: () => {
			message.success(COMMONS.SUCCESS_CREATE_MSG);
			queryClient.invalidateQueries({
				queryKey: queries.memberAttributes._def,
			});
		},
	});
};

export const useUpdateMemberAttributes = (client: FeatureClient) => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (mutateData: {
			memberAttributeId: number;
			data: UpdateMemberAttributeRequest;
		}) =>
			client.updateMemberAttribute(
				mutateData.memberAttributeId,
				mutateData.data,
			),
		// mutationKey: queries.memberAttributes.detail(memberAttributeId).queryKey,
		onSuccess: () => {
			message.success(COMMONS.SUCCESS_UPDATE_MSG);
			queryClient.invalidateQueries({
				queryKey: queries.memberAttributes._def,
			});
		},
	});
};

export const useUpdateMemberAttributesOrder = (client: FeatureClient) => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: client.updateMemberAttributeOrder,
		mutationKey: queries.memberAttributes._def,
		onSuccess: () => {
			message.success(COMMONS.SUCCESS_UPDATE_MSG);
			queryClient.invalidateQueries({
				queryKey: queries.memberAttributes._def,
			});
		},
	});
};

export const useDeleteMemberAttribute = (
	client: FeatureClient,
	memberAttributeId: MemberAttribute["memberAttributeId"],
) => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: client.deleteMemberAttribute,
		mutationKey: queries.memberAttributes.detail(memberAttributeId).queryKey,
		onSuccess: () => {
			message.success(COMMONS.SUCCESS_DELETE_MSG);
			queryClient.invalidateQueries({
				queryKey: queries.memberAttributes._def,
			});
		},
	});
};
